<template>
  <div>
    <div class="small text-muted-more" id="loan-application-decision-label">
      {{ $t('LoanApplicationTimeline.decision') }}
    </div>
    <div class="small font-weight-bold" id="loan-application-decision">
      {{ $t('LoanApplicationTimeline.status.' + application.status) }}
    </div>
    <div class="text-muted small mb-2" id="loan-application-submitted-date">
      {{ $d(application.submittedDate) }}
    </div>

    <div class="small text-muted-more" id="loan-application-cancellation-reason-label">
      {{ $t('LoanApplicationTimeline.reason') }}
    </div>
    <div class="text-warning small" id="loan-application-rejection-reason">
      {{ $t('LoanApplicationTimeline.rejectionReason.' + application.status) }}
    </div>
  </div>
</template>
<script>

export default {
  name: 'CancelledStageComponent',
  props: ['application']
}
</script>
